import { useRegionData } from 'approot/shared/region/region.apollo';
import {
  ACTIVITY_BUILDER_A4_LONG_SIDE,
  ACTIVITY_BUILDER_A4_SHORT_SIDE,
} from 'approot/activity-builder/activity-builder.constants';
import * as Styled from './activity-preview.style';
import { ActivitiesPreviewButton } from './activities-preview-skeleton.style';

const ActivitiesPreviewSkeleton = () => {
  const {
    regionBanner: { height },
  } = useRegionData();

  const ratio =
    (ACTIVITY_BUILDER_A4_SHORT_SIDE / ACTIVITY_BUILDER_A4_LONG_SIDE) * 100;

  return (
    <Styled.ActivityContainer bannerHeight={height}>
      <Styled.ActivityCarousel>
        <ActivitiesPreviewButton ratio={ratio} />
      </Styled.ActivityCarousel>
      <Styled.ActivityThumbnails>
        <Styled.ActivityThumbnailsScroll>
          <Styled.ActivityThumbnailsWrapper>
            <Styled.ActivityThumbnail>
              <ActivitiesPreviewButton ratio={ratio} />
            </Styled.ActivityThumbnail>
            <Styled.ActivityThumbnail>
              <ActivitiesPreviewButton ratio={ratio} />
            </Styled.ActivityThumbnail>
            <Styled.ActivityThumbnail>
              <ActivitiesPreviewButton ratio={ratio} />
            </Styled.ActivityThumbnail>
          </Styled.ActivityThumbnailsWrapper>
        </Styled.ActivityThumbnailsScroll>
      </Styled.ActivityThumbnails>
    </Styled.ActivityContainer>
  );
};

export default ActivitiesPreviewSkeleton;
